var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 items-center content-center flex flex-col",
      staticStyle: { width: "6.875rem" },
    },
    [
      _vm.hasData
        ? _c("progress-circle", {
            attrs: {
              diameter: 65,
              "circle-width": 6,
              "completed-steps": _vm.completed,
              "total-steps": _vm.total,
              "start-color": _vm.color,
              "circle-color": "#9ADAF0",
              "stop-color": _vm.color,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "top-1/2 left-1/2 items-center content-center",
          staticStyle: { "margin-top": "-42%" },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }